<template>
  <div>
    <b-form-select v-model="selected" :options="options"></b-form-select>
  </div>
</template>

<script>
export default {
  name: "purchase-plan-status-select",
  props: {
    value: {
      type: String,
      default: undefined
    },
    placeholder: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      selected: this.value || null,
      options: [
        { value: null, text: this.placeholder ? this.placeholder : this.$t('Please select {something}', { something: this.$t('status') || 'Status' }) },
        { value: 'draft', text: this.$t('purchase_plans.statuses.draft') },
        { value: 'published', text: this.$t('purchase_plans.statuses.published') },
        { value: 'in_review', text: this.$t('purchase_plans.statuses.in_review') },
        { value: 'approved', text: this.$t('purchase_plans.statuses.approved') },
        { value: 'rejected', text: this.$t('purchase_plans.statuses.rejected') },
        { value: 'cancel', text: this.$t('purchase_plans.statuses.cancel') }
      ]
    }
  },
  watch: {
    selected(val, oldVal) {
      if (val !== oldVal) {
        this.$emit('input', val);
      }
    },
    value(val) {
      this.selected = val !== this.selected ? val ?? null : this.selected;
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event)
    },
    clearAll() {
      this.$emit('input', undefined)
    }
  }
}
</script>

<style scoped>
</style>
